(() => {
  const sourcePair = 'tee-pair-v1', sourceExtra = 'tee-extra-v1', sourceQualifier = 'tee-extra-qualifier-v1';
  const money = cents => new Intl.NumberFormat('en-US', {style:'currency',currency:'USD'}).format(cents / 100);
  function init(offer) {
    if (offer.dataset.ready) return;
    offer.dataset.ready = 'true';
    const root = offer.closest('[data-apparel-section]'), find = selector => offer.querySelector(selector);
    const kind = offer.dataset.teeOffer;
    const products = [];
    const more = find('[data-offer-more]');
    let page = 1, shown = 0, hasMore = true, loading = false;
    const first = find('[data-offer-first]'), second = find('[data-offer-second]'), button = find('[data-offer-add]');
    const status = find('[data-offer-status]'), normalSelect = root.querySelector('[data-variant-select]');
    let selectedProduct = null, pending = false;
    // The regular template stores formatted prices; use the offer's own numeric variant data.
    const numericVariants = JSON.parse(find('[data-offer-current]').textContent);
    const currentVariant = () => numericVariants.find(v => String(v.id) === first.value);
    const secondVariant = () => selectedProduct?.variants.find(v => String(v.id) === second.value);
    const firstEligible = v => v.available && (kind !== 'pair' || (v.price === 3200 && v.compare <= v.price));
    if (!numericVariants.some(firstEligible) || !offer.dataset.offerCatalog) return;
    numericVariants.filter(firstEligible).forEach(v => first.add(new Option(v.title, String(v.id))));
    function renderProduct(p) {
      const tile = document.createElement('button'); tile.type = 'button'; tile.className = 'ss-tee-offer-design';
      tile.setAttribute('aria-pressed', 'false'); tile.setAttribute('aria-label', 'Select ' + p.title);
      const img = document.createElement('img'); img.src = p.image; img.alt = ''; img.loading = 'lazy';
      const label = document.createElement('span'); label.textContent = p.title; tile.append(img,label);
      tile.addEventListener('click', () => {
        if (pending) return;
        selectedProduct = p; second.replaceChildren(new Option('Select an option', ''));
        p.variants.filter(v => v.available && v.price === 3200 && v.compare <= v.price).forEach(v => second.add(new Option(v.title, String(v.id))));
        find('[data-offer-second-row]').hidden = false;
        find('[data-offer-picker]').querySelectorAll('button').forEach(b => b.setAttribute('aria-pressed', String(b === tile)));
        status.textContent = ''; update();
      });
      find('[data-offer-picker]').append(tile);
    }
    async function showBatch() {
      if (loading || pending) return;
      loading = true; more.disabled = true; more.textContent = 'Loading…';
      const beforeShown = shown;
      try {
        while (products.length - shown < 6 && hasMore) {
          const url = new URL(offer.dataset.offerCatalog, location.origin);
          url.searchParams.set('page', String(page));
          const response = await fetch(url, {headers:{Accept:'text/html'}});
          if (!response.ok) throw new Error('Unable to load shirts. Please try again.');
          const data = await response.json();
          if (!Array.isArray(data.products)) throw new Error('Unable to load shirts. Please try again.');
          data.products.filter(p=>p.variants.some(v=>v.available && v.price===3200 && v.compare<=v.price)).forEach(p=>{if(!products.some(existing=>existing.id===p.id))products.push(p);});
          hasMore = data.hasMore === true; page++;
        }
        const end = Math.min(shown + 6, products.length);
        while (shown < end) renderProduct(products[shown++]);
        if (!shown) status.textContent = 'No eligible shirts are available right now.';
        else status.textContent = '';
        more.hidden = !hasMore && shown >= products.length;
      } catch(error) { status.textContent = error.message; more.hidden=false; }
      finally { loading=false; more.disabled=false; more.textContent=shown===beforeShown ? 'Try again' : 'Show more shirts'; }
    }
    more.addEventListener('click', showBatch);

    function update() {
      const a = currentVariant(), b = secondVariant();
      const ready = firstEligible(a || {}) && b?.available;
      button.disabled = pending || !ready;
      find('[data-offer-add-label]').textContent = pending ? 'Adding…' : ready ? (kind === 'pair' ? 'Add both tees · $39' : 'Add both to cart') : 'Choose both sizes to continue';
      const base = kind === 'pair' ? 3200 : (a?.price || numericVariants.find(firstEligible)?.price || 0);
      find('[data-offer-original]').textContent = money(base + 3200);
      find('[data-offer-total]').textContent = money(kind === 'pair' ? 3900 : base + 1400);
    }
    function syncFirst() {
      if (pending) return;
      const v = numericVariants.find(v => String(v.id) === normalSelect.value);
      first.value = v && firstEligible(v) ? String(v.id) : '';
      update();
    }
    // Choosing an offer size does not alter the regular single-item purchase.
    first.addEventListener('change', update); second.addEventListener('change', update);
    root.addEventListener('click', e => { if (e.target.closest('[data-option-value]')) queueMicrotask(syncFirst); });
    normalSelect.addEventListener('change', syncFirst);
    offer.addEventListener('toggle', () => { if (!offer.open) return; if (!first.value) syncFirst(); if (!shown) showBatch(); });
    button.addEventListener('click', async () => {
      if (pending) return;
      const a = currentVariant(), b = secondVariant();
      if (!firstEligible(a || {}) || !b?.available || b.price !== 3200 || b.compare > b.price) return;
      pending = true; more.disabled=true; status.textContent = ''; update();
      first.disabled = second.disabled = true;
      find('[data-offer-picker]').querySelectorAll('button').forEach(b => b.disabled = true);
      const route = window.Shopify?.routes?.root || '/';
      const requestId = crypto.randomUUID();
      let attempted = false, completed = false;
      try {
        const before = await fetch(route + 'cart.js', {headers:{Accept:'application/json'}});
        if (!before.ok) throw new Error('Unable to check your cart. Please try again.');
        const cart = await before.json();
        const markers = kind === 'pair' ? [sourcePair] : [sourceExtra, sourceQualifier];
        if (cart.items.some(i => markers.includes(i.properties?._ss_pdp_offer))) throw new Error(kind === 'pair' ? 'You already have a pair offer in your cart. View your cart to change it.' : 'You already have a T-shirt add-on in your cart. View your cart to change it.');
        const latest = await Promise.all([offer.dataset.currentHandle, selectedProduct.handle].map(async handle => {
          const response = await fetch(route+'products/'+encodeURIComponent(handle)+'.js');
          if (!response.ok) throw new Error('Unable to check these sizes. Please try again.');
          return response.json();
        }));
        const freshFirst = latest[0].variants.find(v => v.id === a.id), freshSecond = latest[1].variants.find(v => v.id === b.id);
        if (!freshFirst?.available || !freshSecond?.available) throw new Error('One of these sizes just sold out. Please refresh and choose another size.');
        if (freshSecond.price !== 3200 || freshSecond.compare_at_price > freshSecond.price || freshFirst.price !== a.price || (kind === 'pair' && (freshFirst.price !== 3200 || freshFirst.compare_at_price > freshFirst.price))) throw new Error('This offer has changed. Please refresh to see the current price.');
        const items = kind === 'pair' ? [
          {id:a.id,quantity:1,properties:{_ss_pdp_offer:sourcePair,_ss_pair_slot:'1'}},
          {id:b.id,quantity:1,properties:{_ss_pdp_offer:sourcePair,_ss_pair_slot:'2'}}
        ] : [
          {id:a.id,quantity:1,properties:{_ss_pdp_offer:sourceQualifier}},
          {id:b.id,quantity:1,properties:{_ss_pdp_offer:sourceExtra}}
        ];
        items.forEach(i => i.properties._ss_offer_request = requestId);
        attempted = true;
        const response = await fetch(route+'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(typeof result.description === 'string' ? result.description : 'Unable to add both items. Please try again.');
        completed = true;
        const updatedResponse = await fetch(route+'cart.js',{headers:{Accept:'application/json'}});
        const updatedCart = updatedResponse.ok ? await updatedResponse.json() : null;
        if (updatedCart) document.querySelectorAll('[data-ss-cart-count]').forEach(counter => {counter.textContent=String(updatedCart.item_count);counter.hidden=updatedCart.item_count===0;});
        const discounted = updatedCart?.items.some(i => i.properties?._ss_pdp_offer === (kind === 'pair' ? sourcePair : sourceExtra) && i.final_price === (kind === 'pair' ? 1950 : 1400));
        status.textContent = discounted ? (kind === 'pair' ? 'Both tees added to your cart · $39.' : 'Both items added to your cart · T-shirt $14.') : 'Both items added. View your cart to confirm the current offer price.';
        find('[data-offer-cart]').hidden = false;
        document.dispatchEvent(new CustomEvent('cart:updated',{detail:{source:'ss-apparel-offer'}}));
      } catch(error) {
        if (attempted && !completed) {
          // If stock validation partially added the request, remove only this request's lines.
          try {
            const check = await fetch(route+'cart.js',{headers:{Accept:'application/json'}});
            const cart = await check.json();
            const updates = Object.fromEntries(cart.items.filter(i => i.properties?._ss_offer_request === requestId).map(i => [i.key,0]));
            if (Object.keys(updates).length) await fetch(route+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({updates})});
          } catch (_) { /* The cart link remains available to inspect after a network failure. */ }
        }
        status.textContent = completed ? 'Both items added. View your cart to confirm the current offer price.' : error.message || 'Unable to add both items. Please try again.';
        find('[data-offer-cart]').hidden = false;
      }
      finally { pending=false; more.disabled=loading; first.disabled=second.disabled=false; find('[data-offer-picker]').querySelectorAll('button').forEach(b => b.disabled=false); update(); }
    });
    syncFirst(); offer.hidden = false;
  }
  const initAll = () => document.querySelectorAll('[data-tee-offer]').forEach(init);
  // The independent async script follows its complete offer markup.
  initAll();
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initAll);
  document.addEventListener('shopify:section:load',initAll);
})();
